import { createContext, useContext } from 'react';

type SubcriptionProduct = {
  id: string;
};

export type Subscription = {
  product: SubcriptionProduct | null;
  addons: null | { product: SubcriptionProduct | null }[];
  alert: unknown;
};

export type SubscriptionContext = {
  loading: boolean;
  subscription: Subscription | null;
};

export const subscriptionContext = createContext<SubscriptionContext | null>(null);

export function SubscriptionProviderContext({
  children,
  subscription,
}: {
  children: React.ReactNode;
  subscription: SubscriptionContext;
}) {
  return (
    <subscriptionContext.Provider value={subscription}>{children}</subscriptionContext.Provider>
  );
}

export function usePrimarySubscription() {
  const context = useContext(subscriptionContext);
  if (!context) {
    throw new Error('useCustomerType must be used within a CustomerTypeProvider');
  }
  return context;
}
